import { shallowEqual, useSelector } from "react-redux";
import { useTwilioClient } from "../../hooks/twilio/useTwilioClient";
import { useEffect } from "react";
import NewConversationContainer from "../new-conversations/NewConversationContainer/NewConversationContainer";
import { AppState } from "../../store";
import { Box } from "@twilio-paste/box";
import stylesheet from "../../styles";
import NewConversationsContainer from "../new-conversations/NewConversationsContainer";
import useAppAlert from "../../hooks/useAppAlerts";

export const ConversationPage = () => {
  const { client } = useTwilioClient();
  const [alertsExist] = useAppAlert();

  // shallowEqual: re-render solo se i campi di openedConversation cambiano,
  // non per ogni aggiornamento di altre conversazioni nella lista.
  const openedConversation = useSelector(
    (state: AppState) =>
      state.conversations.items.find((c) => c.twilioSid === state.sid),
    shallowEqual
  );

  return (
    <Box style={stylesheet.appContainer(alertsExist)}>
      <NewConversationsContainer client={client} />
      <Box
        style={{
          ...stylesheet.messagesWrapper,
          minWidth: 0,
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <NewConversationContainer
          client={client}
          conversation={openedConversation!}
        />
      </Box>
    </Box>
  );
};
